import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { RetailerService } from "src/app/features/retailers/retailer.service";
import { InvoiceService } from "../invoice.service";
import { ToastrService } from "ngx-toastr";
import { map } from "rxjs/internal/operators/map";
import { Observable } from "rxjs";
import { startWith } from "rxjs/operators";

@Component({
  selector: "app-email-invoice",
  templateUrl: "./email-invoice.component.html",
  styleUrls: ["./email-invoice.component.scss"],
  providers: [ToastrService],
})
export class EmailInvoiceComponent
  extends FeaturesBaseComponent
  implements OnInit
{
  sendEmailForm: FormGroup;
  filteredOptions: Observable<string[]>;
  options: any = [];
  retailerDetails: any;
  invoiceId: number;
  dataLocalUrl: string;
  retailerEmailCtrl = new FormControl();
  constructor(
    private retailerService: RetailerService,
    private activeRoute: ActivatedRoute,
    private invoiceService: InvoiceService,
    private router: Router
  ) {
    super();
    this.invoiceId = this.activeRoute.snapshot.params.id;
    this.invoiceService.getInvoicePdf(this.invoiceId).subscribe((res) => {
      let data: any = res;
      var file = new Blob([data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(file);
      // set preview url
      this.dataLocalUrl = fileURL;
    });
    this.retailerService.getRetailerBusinessNames().subscribe((res) => {
      if (res["httpcode"] == 200) {
        this.retailerDetails = res["data"];
        this.options = this.retailerDetails;
      }
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initForm();
    this.filteredOptions = this.retailerEmailCtrl.valueChanges.pipe(
      startWith(""),
      map((value) => this._filterEmail(value))
    );
  }
  private _filterEmail(value: any): string[] {
   
    const filterValue = value.toLowerCase();
    return this.options.filter((option) =>
      option?.email?.toLowerCase().includes(filterValue)
    );
  }
  initForm() {
    this.sendEmailForm = new FormGroup({
      retailerEmail: new FormControl(this.retailerEmailCtrl.value),
    });
  }

  selectedRetailerDetails(e) {
   
    // this.sendEmailForm.get('retailerEmail').setValue()
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onSendEmail() {
    if (!this.sendEmailForm.valid) {
      return;
    }
    let email: any = [];
    email.push(this.retailerEmailCtrl.value);
    this.invoiceService.emailInvoice(email, this.invoiceId).subscribe((res) => {
      if (res["httpcode"] == 200) {
        this.toastrService.success("Email sent successfully", "📨 Sent");
        this.router.navigate(["features/reports/invoices/"]);
      }
    });
  }

  onCancel() {
    this.initForm();
    this.router.navigate([
      `features/reports/invoices/edit-invoice/${this.invoiceId}`,
    ]);
    // this.location.back();
  }
}
